<template>
  <page>
    <div slot="head" class="page-head-default">
      <img src="../../assets/imgs/back.png" alt="" @click="goRouter('/')">
      {{i18n.title}}
    </div>
    <div class="wallet-tips" v-html="i18n.wallet_tips"></div>
    <div class="wallet-balance wallet-main-balance">
      <div class="wallet-balance-body">
        <div class="wallet-balance-warp">
          <div class="wallet-balance-label">{{i18n.deposit}}</div>
          <div class="wallet-balance-value">{{user && user.pcurrencyName}}{{user && user.pyajinBalance || 0}}</div>
          <div class="wallet-balance-label">{{i18n.frozen}}: {{user.pyajin}}</div>
        </div>
        <div v-if="user && user.pyajinBalance" class="wallet-main-btn" @click="goRouter('/wallet_out')">
          <img src="../../assets/imgs/wallet_push.png">
          <span>{{i18n.wallet_out}}</span>
        </div>
        <div v-else class="wallet-main-btn" @click="inDeposit">
          <img src="../../assets/imgs/wallet_pull.png">
          <span>{{i18n.wallet_in}}</span>
        </div>
      </div>
      <div class="wallet-balance-agreement">{{ i18n.wallet_pay_agreement }} <span @click="onDepositAgreement">{{ i18n.wallet_deposit_agreement }}</span></div>
    </div>
    <div class="wallet-balance wallet-main-balance">
      <div class="wallet-balance-body">
        <div class="wallet-balance-warp">
          <div class="wallet-balance-label">{{i18n.balance}}</div>
          <div class="wallet-balance-value">{{user && user.pcurrencyName}}{{user && user.pbalance || 0}}</div>
          <!-- <div class="wallet-balance-label">{{i18n.deposit}}: {{user.pyajin}}</div> -->
        </div>
        <div class="wallet-main-btn" @click="onWalletIn">
          <img src="../../assets/imgs/wallet_pull.png">
          <span>{{i18n.wallet_in}}</span>
        </div>
      </div>
      <div class="wallet-balance-agreement">{{ i18n.wallet_pay_agreement }} <span @click="onBalanceAgreement">{{ i18n.wallet_balance_agreement }}</span></div>
    </div>
    <!-- <div class="wallet-btn">
      <div @click="goRouter('/wallet_in')">
        <img src="../../assets/imgs/wallet_pull.png">
        <span>{{i18n.wallet_in}}</span>
      </div>
      <div @click="goRouter('/wallet_out')">
        <img src="../../assets/imgs/wallet_push.png">
        <span>{{i18n.wallet_out}}</span>
      </div>
    </div> -->
  </page>
</template>

<script>
import { USER_INFO } from '../../apis/user.js'
import { mapState } from 'vuex'
import { PREPAY_FOR_WEB } from '../../apis/payment'
export default {
  computed: {
    ...mapState(['user', 'lang']),
    i18n () {
      return this.$t('mine')
    },
    i18nMsg () {
      return this.$t('msg')
    }
  },
  data () {
    return {
      price: 60,
      qrcode: ''
    }
  },
  methods: {
    loadUser () {
      this.$get(
        USER_INFO,
        {},
        resp => {
          if (resp.user) {
            this.$store.commit('user', resp.user)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user,
              confirmText: this.i18nMsg.retry,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              this.loadUser()
            })
          }
        },
        error => {
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.loadUser()
          })
          console.log(error)
        }
      )
    },
    goRouter (path) {
      this.$router.push(path)
    },
    inDeposit () {
      this.$loading(true)
      this.$post(
        `${PREPAY_FOR_WEB}${this.qrcode ? '/' + this.qrcode : ''}?amount=${this.price}`,
        {},
        res => {
          this.$loading(false)
          if (res.data && res.data.url) {
            window.location.href = res.data.url
          } else {
            this.$toast(res.msg)
          }
        },
        err => {
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    onWalletIn () {
      let temp = Number(this.user.pyajin) + Number(this.user.pyajinBalance)
      console.log(temp)
      if (temp === 0) {
        this.$confirm({
          title: this.$t('msg.title'),
          content: this.$t('msg.recharge_tips'),
          confirmText: this.$t('msg.confirm'),
          cancelText: this.$t('msg.cancel')
        }).then(() => {
          this.inDeposit()
        })
      } else {
        this.goRouter('/wallet_in')
      }
    },
    onDepositAgreement () {
      if (this.lang === 'zh-CN') {
        window.open('https://app.raysen.tech/content/deposit_agreement_zh-CN.html')
      } else {
        window.open('https://app.raysen.tech/content/deposit_agreement_en-US.html')
      }
    },
    onBalanceAgreement () {
      if (this.lang === 'zh-CN') {
        window.open('https://app.raysen.tech/content/balance_agreement_zh-CN.html')
      } else {
        window.open('https://app.raysen.tech/content/balance_agreement_en-US.html')
      }
    }
  },
  created () {
    this.qrcode = this.$route.query.qrcode
    this.price = this.$route.query.price || 60
    this.loadUser()
    if (this.qrcode) {
      this.inDeposit()
    }
  }
}
</script>

<style lang="less">
.wallet-main-balance {
  box-shadow: 10px 10px 20px 10px rgba(0,0,0,0.2);
}
.wallet-balance{
  margin: 40px;
  background: linear-gradient(90deg,#EBD460 0%,#E5BE53 100%);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 40px 60px 20px;
  color: #333333;
  &-body{
    display: flex;
    align-items: center;
    padding-bottom: 20px;
  }
  &-warp{
    flex: 1;
  }
  &-label{
    font-size: 32px;
  }
  &-value{
    font-size: 64px;
    font-weight: bold;
  }
  &-more{
    & img{
      width: 20px;
      height: 30px;
      display: block;
    }
  }
  .wallet-balance-agreement {
    font-size: 24px;
    span {
      font-size: 24px;
      color: #267AFF;
    }
  }
}
.wallet-main-btn {
  width: 230px;
  height: 72px;
  line-height: 72px;
  border-radius: 10px;
  text-align: center;
  border: 2px solid #333333;
  font-size: 28px;
  font-weight: 500;
  color: #333333;
  margin: 0 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  & img{
    width: 40px;
    height: 40px;
    display: block;
  }
  & span{
    padding-left: 15px;
  }
}
.wallet-tips {
  padding: 20px 60px 0;
  color: #606266;
}
</style>
